import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import NativeComponent from "../NativeComponent";
import * as nativeComponentListener from "../../../../api/nativeComponentListener";

const nativeComponentAbility = NativeComponent.nativeComponentAbility

class NativeEndcard extends VisibleComponent {
    constructor (options) {
        const action = nativeComponentAPI.createEndCard
        super(action, {
            ...options,
            params: options
        })
    }

    /**
     * Native EC关闭按钮点击事件
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onCloseBtnClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onCloseBtnClicked(this.getId(), cb)
    }
}

export default NativeEndcard